import $ from 'jquery'

export let key;

$.ajax({
    type: 'get',
    async: false,
    url: '/ip/ip.json',
    data: {},
    success: (res) => {
        // alert(JSON.stringify(res))
       
         key = res.key

    }
})




